import { Navigate } from 'react-router-dom';
import Page from '../../../components/shared/Page/Page';
import AgentForm from '../../../components/agents/AgentForm/AgentForm';
import { WorkflowType } from '../../../interfaces/App';
import useGetAgentById from '../../../hooks/useGetAgentById';
import Loading from '../../../components/shared/Loading/Loading';

const EditAgent = () => {
  const { agent, knowledge, isLoading, shouldNavigate } = useGetAgentById();

  if (shouldNavigate) {
    return <Navigate to="/dashboard" />;
  }

  // TODO: Check if a knowledge that is deleted (archived) is really
  // disassociated with the an existing agent.
  // `knowledge` stays undefined for an agent without a knowledge base (it's
  // optional), so it isn't part of the loading condition.
  if (isLoading || !agent) return <Loading />;

  return (
    <Page withBackground hideMainMenu>
      <AgentForm
        agent={agent}
        knowledge={knowledge}
        workflow={WorkflowType.EDIT}
      />
    </Page>
  );
};

export default EditAgent;
